// initVideoGridColsDetector.js
const initVideoGridColsDetector = () => {
    const COOKIE   = 'videoGridCols';
    const MAX_AGE  = 60 * 60 * 24 * 365;   // 1 year
    const SECURE   = location.protocol === 'https:' ? ';Secure' : '';


    //variable from _custom.scss
    const getCols = () =>
        parseInt(
            getComputedStyle(document.documentElement)
                .getPropertyValue('--video-grid-cols')
                .trim() || '5',
            10
        );


    const getCookie = (name) =>
        document.cookie
            .split('; ')
            .find(row => row.startsWith(name + '='))
            ?.split('=')[1];


    const syncCookie = () => {
        const cols   = getCols();
        const stored = parseInt(getCookie(COOKIE) || '0', 10);

        if (!stored || cols !== stored) {
            document.cookie =
                COOKIE + '=' + cols +
                ';path=/;max-age=' + MAX_AGE +
                ';SameSite=Lax' + SECURE;
        }
    };

    // --- init + debounce --------------------------------------------
    syncCookie();

    let tid;
    window.addEventListener('resize', () => {      // při resize
        clearTimeout(tid);
        tid = setTimeout(syncCookie, 200);           // debounce 200 ms
    });
};

export default initVideoGridColsDetector;